const ROUTE_BASE = '/apps';

const nuvemEnvioBaseRoutes = {
  nuvemenvio: `${ROUTE_BASE}/nuvemenvio`,
  envionubear: `${ROUTE_BASE}/envionube/ar`,
  envionubemx: `${ROUTE_BASE}/envionube/mx`,
};

export const PARTNER_APPS_ROUTES = {
  apps: ROUTE_BASE,
  appsDetail: `${ROUTE_BASE}/:id`,
  widgets: `${ROUTE_BASE}/widgets`,
  nuvempago: `${ROUTE_BASE}/nuvempago`,
  nuvempagoBr: `${ROUTE_BASE}/nuvempago-app-br`,
  ...nuvemEnvioBaseRoutes,
  nuvemenvioDropoff: `${nuvemEnvioBaseRoutes.nuvemenvio}/#/dropoff_points`,
  nuvemenvioExternalSaleOrders: `${nuvemEnvioBaseRoutes.nuvemenvio}/#/dashboard?&externalSaleIds=`,
  nuvemenvioExternalSaleOrdersAr: `${nuvemEnvioBaseRoutes.envionubear}/#/dashboard?&externalSaleIds=`,
  nuvemenvioExternalSaleOrdersMx: `${nuvemEnvioBaseRoutes.envionubemx}/#/dashboard?&externalSaleIds=`,
  nuvemenvioConfigurations: `${nuvemEnvioBaseRoutes.nuvemenvio}/#/configurations`,
  nuvemenvioBilling: `${nuvemEnvioBaseRoutes.nuvemenvio}/#/billing`,
  envionubeBillingAr: `${nuvemEnvioBaseRoutes.envionubear}#/billing`,
  envionubeBillingMx: `${nuvemEnvioBaseRoutes.envionubemx}#/billing`,
  testApplication: `${ROUTE_BASE}/test-application`,
  authorization: `${ROUTE_BASE}/:id/authorize`,
  payUAuthorization: `${ROUTE_BASE}/payu/authorization`,
  priceTables: `${ROUTE_BASE}/price-tables`,
};
